import AbstractDispatcher from 'frontools/abstract/AbstractDispatcher';
import Cache from 'frontools/data/Cache';

export default class GamesState extends AbstractDispatcher {

    public static instance        : GamesState;
    public static key               : string;
    private _key                    : string;
    private _data                   : Object;
    
    
    constructor() {
        super();

        GamesState.instance = this;

        this._data = Cache.get('states', {});
    };

    
    /*
     * save - Save game state
     * @param {Object} data - game data
     * 
     */
    public save(data: Object): void {
        // We make sure to keep only the highest score
        if (this._data[GamesState.key] && this._data[GamesState.key].score > data['score']) {
            data['score'] = this._data[GamesState.key].score;
        }

        this._data[GamesState.key] = data;

        Cache.set('states', this._data, true, true);
    };


     /*
     * load - Load game state
     * @returns {Object} data - game data
     * 
     */
    public get(key: string = GamesState.key): Object {
        return this._data[key] || this._data;
    };

}